// UI komponente
import { Pagination } from "services/search";

// Tipovi i konstante
import { Leasing, LeasingEditFormValues, LeasingRow } from "./types";
import { DataWithPagination } from "services/api/types";

// Transformacije
import {
  transformLeasing,
  transformLeasingOnCreate,
  transformLeasingOnUpdate,
  transformLeasingRow,
} from "./transformations";

// API servisi
import { createApiCall, paginatedApiCall } from "services/api/createApiCall";
import { transformErrorResponse } from "services/api/transformation";




/*---------------------------------------------------------------------------------------
 CALCULATION LEASING SEARCH
-----------------------------------------------------------------------------------------*/

export const getLeasingsAPI = async (
  pagination: Pagination,
  name?: string | null
): Promise<DataWithPagination<LeasingRow>> => {
  let path = `/v1/expenses/leasing?name=`;

  if (name) path += `${name}`;

  return await paginatedApiCall(
    path,
    pagination,
    transformLeasingRow
  );
};

/*---------------------------------------------------------------------------------------
    CALCULATION LEASING - BY ID
-----------------------------------------------------------------------------------------*/
export const getLeasingAPI = async (
  id: string
): Promise<Leasing> => {
  const response = await createApiCall(
    {
      path: `/v1/expenses/leasing/${id}`,
      method: "GET",
    },
    {
      getMessage: {
        error: (error: any) => `${error.response.data.message}`,
      },
    }
  )();

  return transformLeasing(response.data);
};

/*---------------------------------------------------------------------------------------
    CALCULATION LEASING - CREATE
-----------------------------------------------------------------------------------------*/
export const createLeasingAPI = async (
  formValues: LeasingEditFormValues
): Promise<Leasing> => {
  const response = await createApiCall(
    {
      path: "/v1/expenses/leasing/",
      method: "POST",
      body: transformLeasingOnCreate(formValues),
    },
    {
      getMessage: {
        success: () => "Leasing postavka je uspješno kreirana",
        error: (error: any) => `${error.response.data.message}`,
      },
    }
  )();

  return transformLeasing(response.data);
};

/*---------------------------------------------------------------------------------------
    CALCULATION LEASING - UPDATE
-----------------------------------------------------------------------------------------*/
export const updateLeasingAPI = async (
  id: string,
  formValues: LeasingEditFormValues
): Promise<Leasing> => {
  const response = await createApiCall(
    {
      path: `/v1/expenses/leasing/${id}`,
      method: "PUT",
      body: transformLeasingOnUpdate(formValues),
    },
    {
      getMessage: {
        success: () => "Leasing postavka je uspješno ažuriran",
        error: (error: any) => `${error.response.data.message}`,
      },
    }
  )();

  return transformLeasing(response.data);
};

/*---------------------------------------------------------------------------------------
    CALCULATION - LEASING - DELETE
-----------------------------------------------------------------------------------------*/
export const deleteLeasingAPI = async (
  id: string
): Promise<Leasing> => {
  const response = await createApiCall(
    {
      path: `/v1/expenses/leasing/${id}`,
      method: "DELETE",
    },
    {
      getMessage: {
        success: () => "Leasing je uspješno obrisana",
        error: (error: any) => `${transformErrorResponse(error)}`,
      },
    }
  )();

  return response.data.deleted;
};

